import { render } from "./MdArrowRightIcon.vue?vue&type=template&id=e3bea126"
import script from "./MdArrowRightIcon.vue?vue&type=script&lang=js"
export * from "./MdArrowRightIcon.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__